import { DEFAULT_RIGHT_OFFSET_BARS } from "../constants";

const MS_PER_SECOND = 1000;

const isKnown = (timeScale, barDurationMs) => timeScale.width > 0 && barDurationMs > 0;

/**
 * Time the pane shows from its left edge to the price axis (the zoom
 * button label, po-chart-visual-spec.md §6).
 *
 * @param {object} timeScale
 * @param {number} barDurationMs
 * @returns {number} seconds, 0 before the first frame or without a resolution
 */
export const visibleSpanSeconds = (timeScale, barDurationMs) =>
  isKnown(timeScale, barDurationMs)
    ? ((timeScale.width / timeScale.barSpacing) * barDurationMs) / MS_PER_SECOND
    : 0;

/**
 * View in which the pane shows `seconds` and ends with the latest bars,
 * with the right offset of a just opened chart. The zoom limits of the
 * time scale apply, so a span too long or too short becomes the nearest
 * possible one.
 *
 * @param {object} timeScale
 * @param {number} seconds
 * @param {number} barDurationMs
 * @returns {{ barSpacing: number, rightOffset: number } | null} px, bars; null before
 *   the first frame or without a resolution
 */
export const visibleSpanView = (timeScale, seconds, barDurationMs) => {
  if (!isKnown(timeScale, barDurationMs) || seconds <= 0) return null;

  const barSpacing = timeScale.clampBarSpacing(
    (timeScale.width * barDurationMs) / (seconds * MS_PER_SECOND),
  );

  return {
    barSpacing,
    rightOffset: timeScale.clampRightOffset(DEFAULT_RIGHT_OFFSET_BARS, barSpacing),
  };
};
